import { render, staticRenderFns } from "./QualityReportSortModal.vue?vue&type=template&id=a074da86&scoped=true&"
import script from "./QualityReportSortModal.vue?vue&type=script&lang=js&"
export * from "./QualityReportSortModal.vue?vue&type=script&lang=js&"
import style0 from "./QualityReportSortModal.vue?vue&type=style&index=0&id=a074da86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a074da86",
  null
  
)

export default component.exports